module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEPSURBVHgB7dWxDoIwEAbg/3By6yP0ETTRxBHfrG+Go4mDvIE+gpNx0fMKicZSoFcZuaQMwPWjpZcD5pgq2O1KGRaZwa407DZleL8IETBXMs7stiuoEcnh+wW8qML84vfVRy2XqwwDLioN1iJUAWTaORa3XohcfQPRHkqsg8gc5I7Xn7njifKP/BYCVobgL0k81blILxTBohOkIoPQGKZBRqE+DHgaDZIERTGw0SDJUASDBvFRIDlku5qV5EXi1oXF2ITFlFsXO13tg+Gjr4KGjnBKnSVBKXWiwSgX0WL0D6LBqJvwOmuLMY4t1+QOn1YR1pHNQZov9u9+W4yV3mZGvsy34jK7MP3KcrrzHL3xBvRu78ssDoMSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/mb3.png
// module id = i2l4
// module chunks = 25